import { render, staticRenderFns } from "./imsUserManagement.vue?vue&type=template&id=18de7ae0&scoped=true&"
import script from "./imsUserManagement.vue?vue&type=script&lang=js&"
export * from "./imsUserManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de7ae0",
  null
  
)

export default component.exports